import React, { FC } from "react";
import { FeatureHighlight } from "./FeatureHighlight";

export const FeatureHighlights: FC = () => {
  return (
    <div className="flex gap-6 mt-6 mb-4 max-md:flex-col px-4">
      <FeatureHighlight
        icon={
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="feature-icon"
          >
            <path
              d="M3.4 20.3999L20.85 12.9199C21.0304 12.8431 21.1842 12.7149 21.2923 12.5513C21.4004 12.3877 21.4581 12.196 21.4581 11.9999C21.4581 11.8038 21.4004 11.6121 21.2923 11.4485C21.1842 11.2849 21.0304 11.1567 20.85 11.0799L3.4 3.5999C3.2489 3.534 3.08377 3.50675 2.91951 3.52061C2.75525 3.53447 2.59702 3.589 2.4591 3.6793C2.32118 3.76959 2.20791 3.8928 2.1295 4.0378C2.0511 4.18281 2.01003 4.34506 2.01 4.5099L2 9.1199C2 9.6199 2.37 10.0499 2.87 10.1099L17 11.9999L2.87 13.8799C2.37 13.9499 2 14.3799 2 14.8799L2.01 19.4899C2.01 20.1999 2.74 20.6899 3.4 20.3999Z"
              fill="#1A2147"
            />
          </svg>
        }
        title="Share your personal payment link"
        description="Anyone can pay you"
      />
      <FeatureHighlight
        icon={
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="feature-icon"
          >
            <path
              d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM12 11.99H19C18.47 16.11 15.72 19.78 12 20.93V12H5V6.3L12 3.19V11.99Z"
              fill="#1A2147"
            />
          </svg>
        }
        title="Test it risk-free with a small payment"
        description="Request just €5, £5 or $5"
      />
      <FeatureHighlight
        icon={
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="feature-icon"
          >
            <path
              d="M14.6901 2.20981L4.33009 11.4898C3.69009 12.0698 4.05009 13.1398 4.91009 13.2198L13.0001 13.9998L8.15009 20.7598C7.93009 21.0698 7.96009 21.4998 8.23009 21.7698C8.53009 22.0698 9.00009 22.0798 9.31009 21.7898L19.6701 12.5098C20.3101 11.9298 19.9501 10.8598 19.0901 10.7798L11.0001 9.99981L15.8501 3.23981C16.0701 2.92981 16.0401 2.49981 15.7701 2.22981C15.6287 2.08543 15.4362 2.00241 15.2342 1.99867C15.0321 1.99493 14.8367 2.07076 14.6901 2.20981Z"
              fill="#1A2147"
            />
          </svg>
        }
        title="Receive your INR in just a few banking business hours"
        description="Need help? Get in touch with our support team."
      />
    </div>
  );
};
